import { messageArray } from './messageArray';
export default {
  returnMessage(code) {
    return messageArray.get(code);
  }
};
